/** @jsx h */
import { h } from 'preact'

const ValidationIcon = ({
  style = {},
  stroke = '#000',
  width = '16.4',
  height = '11.071',
  className = '',
  viewBox = '0 0 16.4 11.071'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_validation-icon ${className}`}
    aria-hidden='true'
  >
    <path
      d='M675.159,710.976,680.841,717l10-10'
      transform='translate(-674.795 -706.646)'
      fill='none'
      stroke={stroke}
      strokeMiterlimit='10'
      strokeWidth='1'
    />
  </svg>
)

export default ValidationIcon
